<div class="gridheight mat-elevation-z8 viewport">
    <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort>
      <ng-container matColumnDef="expandIcon">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element"
          style="width: 32px;border-right: 1px solid currentColor;padding-right: 24px;text-align: center;">
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
        <td mat-cell *matCellDef="let element"> {{element.id}} </td>
      </ng-container>

      <ng-container matColumnDef="generatorName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
        <td mat-cell *matCellDef="let element"> {{element.generatorName}} </td>
      </ng-container>

      <ng-container matColumnDef="contactName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Contact Name </th>
        <td mat-cell *matCellDef="let element"> {{ element.contactName }} </td>
      </ng-container>

      <ng-container matColumnDef="contactEmail">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Contact Email </th>
        <td mat-cell *matCellDef="let element"> {{element.contactEmail}} </td>

        <!-- <td mat-cell *matCellDef="let element">
          <mat-progress-bar mode="determinate" [value]="element.completed_Percentage??0"></mat-progress-bar>
        </td> -->

      </ng-container>

      <ng-container matColumnDef="contactPhone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Contact Phone </th>
        <td mat-cell *matCellDef="let element"> {{element.contactPhone}} </td>
      </ng-container>
      

      <ng-container matColumnDef="lgX_ContactName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Logistics <br /> Contact Name </th>
        <td mat-cell *matCellDef="let element"> {{ element.lgX_ContactName }} </td>
      </ng-container>
      <ng-container matColumnDef="lgX_ContactEmail">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Logistics <br /> Contact Email </th>
        <td mat-cell *matCellDef="let element"> {{element.lgX_ContactEmail}} </td>
      </ng-container>
      <ng-container matColumnDef="lgX_ContactPhone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Logistics <br /> Contact Phone </th>
        <td mat-cell *matCellDef="let element"> {{element.lgX_ContactPhone}} </td>
      </ng-container>

      <ng-container matColumnDef="accountNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Oracle <br /> Account Number </th>
        <td mat-cell *matCellDef="let element"> {{element.accountNumber}} </td>
      </ng-container>
      <ng-container matColumnDef="siteNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Oracle <br /> Site Number </th>
        <td mat-cell *matCellDef="let element"> {{element.siteNumber}} </td>
      </ng-container>
      <ng-container matColumnDef="marketName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Market </th>
        <td mat-cell *matCellDef="let element"> {{element.marketName}} </td>
      </ng-container>
      <ng-container matColumnDef="environment_Fee_FlagDescription">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Environmental Fee Flag </th>
        <td mat-cell *matCellDef="let element"> {{element.environment_Fee_FlagDescription}} </td>
      </ng-container>
      <ng-container matColumnDef="isTipFeeRequiredDescription">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Tip Fee Required </th>
        <td mat-cell *matCellDef="let element"> {{element.isTipFeeRequiredDescription}} </td>
      </ng-container>
      <ng-container matColumnDef="isVRSiteDescription">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> VR Site </th>
        <td mat-cell *matCellDef="let element"> {{element.isVRSiteDescription}} </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Actions</th>
        <td mat-cell *matCellDef="let row">
          <div>
            <button mat-icon-button type="button" class="icon-btn edit-icon" title="Edit" (click)="openAddEditForm(row, 'Edit')">
              <mat-icon>edit</mat-icon>
            </button>
            @if(controlPermissions.deleteCustomer){
              <button mat-icon-button type="button" color="warn" title="Delete" (click)="deleteGenerator(row.id, row.generatorName)" style="color: red;">
                <mat-icon>delete</mat-icon>
              </button>
            }
          </div>
        </td>
      </ng-container>

      <!-- <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length"
            style="color: red;text-align: center;font-weight: 500;">
            No data matching the filter.
          </td>
        </tr> -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <!-- <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length"
            style="color: red;text-align: center;font-weight: 500;">
            No data matching the filter.
          </td>
        </tr> -->

    </table>

    <!-- <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons aria-label="Select page of periodic elements"> -->
    <!-- </mat-paginator>
  </mat-card-content>
</mat-card> -->
</div>
